import { Stack, Typography } from '@mui/material';
import React from 'react';
import Confetti from 'react-confetti';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  contactAssessmentName: string | undefined;
  profileName: string | undefined;
}

const UserDone: React.FC<Props> = ({ contactAssessmentName, profileName }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.userDone}>
      <Confetti className={classes.confetti} numberOfPieces={5000} tweenDuration={125000} friction={1} gravity={0.08} recycle={false} />
      <Stack gap={1} justifyContent={'center'}>
        <Typography className={classes.title} align={'center'}>
          {t('congratulations')}
        </Typography>
        <Typography className={classes.text} align={'center'}>
          {t('userDoneText', { profileName })}
        </Typography>
        <Typography className={cx(classes.text, 'highlight')} align={'center'}>{`${t('persona')}: ${contactAssessmentName}`}</Typography>
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  userDone: {
    width: '100%',
    background: '#FFF',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '8px',
    position: 'relative',
  },
  title: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  text: {
    fontSize: theme.typography.pxToRem(11),
    '&.highlight': {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
  confetti: {
    width: '100%',
    height: '100%',
  },
}));

export default UserDone;
